'use client';

import React, { type FC } from "react";

import { Hero } from '@/sections/Hero'
import { PrimaryFeatures } from "@/sections/PrimaryFeatures";
import { SecondaryFeatures } from "@/sections/SecondaryFeatures";
import { EmpowerBanner } from "@/sections/EmpowerBanner";
import { FlexibleBanner } from "@/sections/FlexibleBanner";
import { ValueProposition } from "@/sections/ValueProposition";
import { Team } from "@/sections/Team";
import { ContactBanner } from "@/sections/ContactBanner";
import { VideoEmbed } from "@/sections/VideoEmbed";
import { VideoBanner } from "@/sections/VideoBanner";

export const sections = {
  'hero': Hero,
  'primary-features': PrimaryFeatures,
  'video-embed': VideoEmbed,
  'video-banner': VideoBanner,
  'empower-banner': EmpowerBanner,
  'flexible-banner': FlexibleBanner,
  'value-proposition': ValueProposition,
  'team': Team,
  'contact-banner': ContactBanner,
  'secondary-features': SecondaryFeatures,
}

export type SectionNames = keyof typeof sections;

export interface Block {
  name: string;
  id?: string;
  [key: string]: unknown;
}

export function isSectionName(name: string): name is SectionNames {
  return name in sections;
}

function isSectionComponent(component: unknown): component is FC<{ data: Block }> {
  return typeof component === 'function';
}

export default function SectionRenderer({ block }: { block: Block }) {
  if (!isSectionName(block.name)) {
    return <div>{`Invalid content.json: Section of name ${block.name} doesn't exist.`}</div>;
  }
  const Component = sections[block.name];

  if (isSectionComponent(Component)) {
    return <Component data={block} />;
  }

  return (
    <div>
      {`The section ${block.name} has not been created yet.`}
    </div>
  );
}
